import { createReducer, on } from '@ngrx/store';
import { nutritionGuideActions } from './nutrition-guide.action';
import { nutritionGuideState } from './nutrition-guide.state';

export const nutritionGuideReducer = createReducer(
  nutritionGuideState,

  // Reset
  on(nutritionGuideActions.reset, () => nutritionGuideState),

  // --- Personal Information ---
  on(nutritionGuideActions.fetchPersonalInformation, (state) => ({
    ...state,
    loading: { ...state.loading, personalInformation: true },
    error: { ...state.error, personalInformation: null }
  })),
  on(
    nutritionGuideActions.fetchPersonalInformationSuccess,
    (state, { personalInformation }) => ({
      ...state,
      personalInformation,
      loading: { ...state.loading, personalInformation: false }
    })
  ),
  on(
    nutritionGuideActions.fetchPersonalInformationFailure,
    (state, { error }) => ({
      ...state,
      loading: { ...state.loading, personalInformation: false },
      error: { ...state.error, personalInformation: error }
    })
  ),

  // --- Food Source ---
  on(nutritionGuideActions.fetchFoodSource, (state) => ({
    ...state,
    loading: { ...state.loading, foodSource: true },
    error: { ...state.error, foodSource: null }
  })),
  on(nutritionGuideActions.fetchFoodSourceSuccess, (state, { foodSource }) => ({
    ...state,
    foodSource,
    loading: { ...state.loading, foodSource: false }
  })),
  on(nutritionGuideActions.fetchFoodSourceFailure, (state, { error }) => ({
    ...state,
    loading: { ...state.loading, foodSource: false },
    error: { ...state.error, foodSource: error }
  })),

  // --- Ideal Calorie Intake ---
  on(nutritionGuideActions.fetchIdealCalorieIntake, (state) => ({
    ...state,
    loading: { ...state.loading, idealCalorieIntake: true },
    error: { ...state.error, idealCalorieIntake: null }
  })),
  on(
    nutritionGuideActions.fetchIdealCalorieIntakeSuccess,
    (state, { idealCalorieIntake }) => ({
      ...state,
      idealCalorieIntake,
      loading: { ...state.loading, idealCalorieIntake: false }
    })
  ),
  on(
    nutritionGuideActions.fetchIdealCalorieIntakeFailure,
    (state, { error }) => ({
      ...state,
      loading: { ...state.loading, idealCalorieIntake: false },
      error: { ...state.error, idealCalorieIntake: error }
    })
  ),

  // --- Food Restriction ---
  on(nutritionGuideActions.fetchFoodRestriction, (state) => ({
    ...state,
    loading: { ...state.loading, foodRestriction: true },
    error: { ...state.error, foodRestriction: null }
  })),
  on(
    nutritionGuideActions.fetchFoodRestrictionSuccess,
    (state, { foodRestriction }) => ({
      ...state,
      foodRestriction,
      loading: { ...state.loading, foodRestriction: false }
    })
  ),
  on(nutritionGuideActions.fetchFoodRestrictionFailure, (state, { error }) => ({
    ...state,
    loading: { ...state.loading, foodRestriction: false },
    error: { ...state.error, foodRestriction: error }
  })),

  // --- Selected Food Source ---
  on(nutritionGuideActions.setSelectedFoodSourceIndex, (state, { index }) => ({
    ...state,
    selectedFoodSourceIndex: index
  })),

  // --- Selected Food Restriction ---
  on(
    nutritionGuideActions.setSelectedFoodRestrictionIndex,
    (state, { index }) => ({
      ...state,
      selectedFoodRestrictionIndex: index
    })
  ),

  // --- Meal Type ---
  on(nutritionGuideActions.fetchMealType, (state) => ({
    ...state,
    loading: { ...state.loading, mealType: true },
    error: { ...state.error, mealType: null }
  })),
  on(nutritionGuideActions.fetchMealTypeSuccess, (state, { mealType }) => ({
    ...state,
    mealType,
    loading: { ...state.loading, mealType: false }
  })),
  on(nutritionGuideActions.fetchMealTypeFailure, (state, { error }) => ({
    ...state,
    loading: { ...state.loading, mealType: false },
    error: { ...state.error, mealType: error }
  })),

  // --- Meal Plan ---
  on(nutritionGuideActions.fetchMealPlan, (state) => ({
    ...state,
    loading: { ...state.loading, mealPlan: true },
    error: { ...state.error, mealPlan: null }
  })),
  on(nutritionGuideActions.fetchMealPlanSuccess, (state, { mealPlan }) => ({
    ...state,
    mealPlan,
    loading: { ...state.loading, mealPlan: false }
  })),
  on(nutritionGuideActions.fetchMealPlanFailure, (state, { error }) => ({
    ...state,
    loading: { ...state.loading, mealPlan: false },
    error: { ...state.error, mealPlan: error }
  })),

  // --- Selected Meal Type ---
  on(nutritionGuideActions.setSelectedMealTypeCode, (state, { code }) => ({
    ...state,
    selectedMealTypeCode: code
  })),

  // --- Selected Date ---
  on(nutritionGuideActions.setSelectedDate, (state, { date }) => ({
    ...state,
    selectedDate: date
  })),

  // --- Overview ---
  on(nutritionGuideActions.fetchOverview, (state) => ({
    ...state,
    loading: { ...state.loading, overview: true },
    error: { ...state.error, overview: null }
  })),
  on(nutritionGuideActions.fetchOverviewSuccess, (state, { overview }) => ({
    ...state,
    overview,
    loading: { ...state.loading, overview: false }
  })),
  on(nutritionGuideActions.fetchOverviewFailure, (state, { error }) => ({
    ...state,
    loading: { ...state.loading, overview: false },
    error: { ...state.error, overview: error }
  })),

  // --- Home Overview ---
  on(nutritionGuideActions.fetchHomeOverview, (state) => ({
    ...state,
    loading: { ...state.loading, homeOverview: true },
    error: { ...state.error, homeOverview: null }
  })),
  on(nutritionGuideActions.fetchHomeOverviewSuccess, (state, { overview }) => ({
    ...state,
    homeOverview: overview,
    loading: { ...state.loading, homeOverview: false }
  })),
  on(nutritionGuideActions.fetchHomeOverviewFailure, (state, { error }) => ({
    ...state,
    loading: { ...state.loading, homeOverview: false },
    error: { ...state.error, homeOverview: error }
  })),

  // --- Eligibility Generation Nourish Plus ---
  on(nutritionGuideActions.fetchEligibilityGenerationNourishPlus, (state) => ({
    ...state,
    loading: { ...state.loading, eligibilityGenerationNourishPlus: true },
    error: { ...state.error, eligibilityGenerationNourishPlus: null }
  })),
  on(
    nutritionGuideActions.fetchEligibilityGenerationNourishPlusSuccess,
    (state, { eligibility }) => ({
      ...state,
      eligibilityGenerationNourishPlus: eligibility,
      loading: { ...state.loading, eligibilityGenerationNourishPlus: false }
    })
  ),
  on(
    nutritionGuideActions.fetchEligibilityGenerationNourishPlusFailure,
    (state, { error }) => ({
      ...state,
      loading: { ...state.loading, eligibilityGenerationNourishPlus: false },
      error: { ...state.error, eligibilityGenerationNourishPlus: error }
    })
  ),

  // --- Process Generation Nourish Plus ---
  on(nutritionGuideActions.fetchProcessGenerationNourishPlus, (state) => ({
    ...state,
    loading: { ...state.loading, processGenerationNourishPlus: true },
    error: { ...state.error, processGenerationNourishPlus: null }
  })),
  on(
    nutritionGuideActions.fetchProcessGenerationNourishPlusSuccess,
    (state, { process }) => ({
      ...state,
      processGenerationNourishPlus: process,
      loading: { ...state.loading, processGenerationNourishPlus: false },
      error: { ...state.error, processGenerationNourishPlus: null }
    })
  ),
  on(
    nutritionGuideActions.fetchProcessGenerationNourishPlusFailure,
    (state, { error }) => ({
      ...state,
      loading: { ...state.loading, processGenerationNourishPlus: false },
      error: { ...state.error, processGenerationNourishPlus: error }
    })
  )
);
